/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import type { TaskList, Cards } from '../../../../common/types.tsx';
import { TASK_LIST, TASK_VARIANTS } from './constants.tsx';
import { Experiments } from './experiments.tsx';
import { UserRole } from './UserRole.tsx';

export const JWM: {
	readonly taskList: TaskList;
	readonly taskVariants: Cards;
	readonly userRole: {
		readonly projectAdmin: 'projectAdmin';
		readonly jiraAdmin: 'jiraAdmin';
		readonly siteAdmin: 'siteAdmin';
	};
	readonly experiments: {
		readonly projectTheming: 'projectTheming';
		readonly isSampleProject: 'isSampleProject';
		readonly isNotSampleProject: 'isNotSampleProject';
		readonly trelloCrossflow: 'trelloCrossflow';
	};
} = {
	taskList: TASK_LIST,
	taskVariants: TASK_VARIANTS,
	userRole: UserRole,
	experiments: Experiments,
} as const;
